import { rem, transparentize } from "polished";
import styled, { css } from "styled-components";

import { CoreRichEditor } from "@/components/editor/primitives/rich-text";

export const Image = styled.img`
  width: ${rem(130)};
  height: ${rem(130)};
  object-fit: cover;
  border-radius: ${rem(4)};
  margin-bottom: ${rem(16)};
`;

export const Link = styled.a`
  font-size: ${rem(14)};
  text-decoration: none;
  color: var(--color-blue-400);
`;

const baseFontStyles = css`
  font-family: "Inter";
  font-size: ${rem(14)};
  line-height: ${rem(24)};
  font-weight: 400;
`;

export const focus = css`
  border: ${rem(1)} solid var(--color-primary);
  box-shadow: 0 0 ${rem(2)} ${rem(2)} ${transparentize(0.85, "#bfd6e7")};
`;

export const disabled = css`
  cursor: not-allowed;
  background-color: var(--color-gray-200);
  color: var(--color-gray-500);

  &:hover {
    background-color: var(--color-gray-200);
    color: var(--color-gray-500);
  }
`;

export const field = css`
  background: transparent;
  border-width: ${rem(1)};
  border-style: solid;
  border-color: var(--color-gray-300);
  border-radius: 0.25rem;

  &:focus-within:not([aria-disabled="true"]) {
    outline: none;
    ${focus};
  }

  &[aria-disabled="true"] {
    cursor: not-allowed;
    ${disabled}

    .ck-content {
      padding: ${rem(12)} ${rem(16)};
      ${baseFontStyles};
    }
  }
`;

export const ResizableContainer = styled.div.attrs({
  tabIndex: -1,
})`
  height: ${rem(196)};
  min-height: ${rem(196)};
  max-height: ${rem(392)};
  overflow: auto;
  resize: vertical;
  ${field};

  // when ck-editor is wrapped with BlockOutline component
  // toolbar is shifted -2px to left, so its aligned with the outline.
  // Here, is not the case
  .document-editor__toolbar {
    left: 0;
  }
`;

export const BasicRichText = styled(CoreRichEditor)`
  margin-bottom: ${rem(160)};

  .ck-content {
    height: 100%;

    p,
    .ck-heading_paragraph {
      ${baseFontStyles};
      color: var(--color-gray-800);
      margin: 0;
    }

    &.ck-editor__editable {
      padding: ${rem(12)} ${rem(16)};

      &.ck-focused {
        outline: none;
        box-shadow: none;
      }
    }

    &.ck-editor__editable,
    &.ck-editor__editable_inline {
      overflow: visible;

      *:first-child {
        margin-top: 0;
      }

      *:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
